var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.size > 1)?_c('div',{staticClass:"c-section-indicator u-desktop-only"},_vm._l((_vm.size),function(i){return _c('div',{staticClass:"c-section-indicator__bulb",class:{ 'is-highlighted': i === _vm.highlighted }})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }